/**
 * A service to implement functions related to Customer Purchases:
 * 1 - the function to get all the Customer Purchases of the authenticated user. This function enables setting
 * parameters to the URL;
 * 2 - the function to get the attributes of the identified Customer Purchase: id, code, document identifier,
 * creation date, total amount, status, store, shipping information and the ordered Items.
 */

import {apiFetch} from '@/_helpers';


export const ordersService = {
    getAll,
    get
};


/**
 *  A function to get all the Customer Purchases of the authenticated user. This function enables setting parameters
 *  to the URL. Right now, the parameters are used to:
 *  (1) obtain the Customer Purchases' of the authenticated user of a specific year (param=year);
 *  (2) to get the next Customer Purchases' of the authenticated user, of the paginated service.
 *
 * @param params
 * @returns {*}
 */
function getAll(params) {
    let str = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');

    return apiFetch("customerspurchases/?" + str);
}


/**
 * A function to get the attributes of the identified Customer Purchase: id, code, document identifier, creation date,
 * total amount, status, store, shipping information and the ordered Items.
 *
 * @param pk
 * @returns {*}
 */
function get(pk) {
    return apiFetch("customerspurchases/" + pk + "/");
}
